<template>
  <div class="history">
    <div class="header" :class="isMobile ? 'mob' : ''">
      <div class="title"><i class="el-icon-refresh"></i> History</div>
      <div class="extras">
        <el-input
          v-model="filter.search"
          placeholder="Search Here!"
          size="small"
        ></el-input>
        <el-select v-model="filter.status" size="small">
          <el-option
            v-for="(item, index) in view"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="body">
      <el-table :data="sourceList" border style="width: 100%">
        <el-table-column label="Application">
          <template slot-scope="scope">
            <h4 class="margin-remove">{{ scope.row.aplikasi }}</h4>
            <small>{{ scope.row.catatan ? scope.row.catatan : "-" }}</small>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="Delegation Date" width="250">
          <template slot-scope="scope">
            {{
              dayjs(scope.row.start_dt).format("YYYY-MM-DD") +
              " - " +
              dayjs(scope.row.end_dt).format("YYYY-MM-DD")
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tlc_create"
          label="TLC Create"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="tlc_asal"
          label="From User"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="tlc_delegasi"
          label="To User"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="status"
          label="Status"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === '1' ? 'primary' : 'danger'"
              disable-transitions
              >{{ scope.row.status === "1" ? "Active" : "Not Active" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="Action" align="center" width="120">
          <el-button
            slot-scope="scope"
            @click="handleDone(scope.row)"
            size="small"
            :loading="loading"
            :type="scope.row.status != '1' ? 'default' : 'primary'"
            v-if="scope.row.tlc_create == activeUser.data.tlc"
            :disabled="scope.row.status != '1'"
            >Done</el-button
          >
          <el-button
            v-else
            slot-scope="scope"
            @click="handleDone(scope.row)"
            size="small"
            :loading="loading"
            :type="scope.row.status != '1' ? 'default' : 'primary'"
            disabled
            >Done</el-button
          >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "history-delegation",
  data() {
    const view = ["Semua", "Active", "Non Active"];
    return {
      view,
      filter: {
        search: "",
        status: "Semua",
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters({ delegationList: "getList", activeUser: "getActiveUser" }),
    sourceList() {
      let result = this.delegationList;

      if (this.filter.search) {
        result = result.filter(
          (item) =>
            (item.aplikasi &&
              item.aplikasi
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) >= 0) ||
            this.dayjs(item.start_dt)
              .format("YYYY-MM-DD")
              .indexOf(this.filter.search.toLowerCase()) >= 0 ||
            this.dayjs(item.end_dt)
              .format("YYYY-MM-DD")
              .indexOf(this.filter.search.toLowerCase()) >= 0 ||
            (item.tlc_create &&
              item.tlc_create
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) >= 0) ||
            (item.tlc_asal &&
              item.tlc_asal
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) >= 0) ||
            (item.tlc_delegasi &&
              item.tlc_delegasi
                .toLowerCase()
                .indexOf(this.filter.search.toLowerCase()) >= 0)
        );
      }

      if (this.filter.status !== "Semua") {
        const status = this.filter.status == "Active" ? "1" : "0";
        result = result.filter((item) => item.status == status);
      }

      return result;
    },
  },
  methods: {
    dayjs,
    handleDone(item) {
      this.loading = true;
      this.$store
        .dispatch("updateDelegation", item.id_delegasi)
        .then((res) => {
          this.$notify.success({
            title: `Update`,
            message: `Delegation has been updated!`,
          });
          this.loading = false;
        })
        .catch((err) => {
          this.$notify.error({
            title: "Error",
            message: err.response.data.error,
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.history {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-top-left-radius: $space * 2;
  border-top-right-radius: $space * 2;
  margin-top: $space;
  border-top: 1px solid darken(white, 10);
  position: relative;
  overflow: auto;
  background-color: white;
  .header {
    padding: $space;
    border-bottom: 1px solid darken(white, 10);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;

    &.mob {
      flex-direction: column;
      gap: $space;
      justify-content: space-around;
      align-items: flex-start;
    }

    .title {
      font-weight: bold;
      font-size: 1.1em;
    }

    .extras {
      display: flex;
      gap: $space;
    }
  }
  .body {
    flex: 1;
    overflow: auto;
  }
}
</style>
